import { createSelector } from 'reselect'
import { RootState } from '../types'

export const getTradingHistoryLoadingState = (state: RootState): RootState['trades']['tradingHistory']['loading'] =>
  state.trades.tradingHistory.loading

export const tradingHistoryIsLoading = createSelector(
  getTradingHistoryLoadingState,
  (state): boolean => state === 'LOADING',
)

export const getTradingHistoryData = (state: RootState): RootState['trades']['tradingHistory']['data'] =>
  state.trades.tradingHistory.data
